export default function NotFound() {
    return (
        <>
         <h1>Sorry. That page is not available.</h1>   
        </>
    )
}
